export const AllowedViews = {
  Lightspeed: "Lightspeed",
  Admin:      "Admin",
}